'use strict';

class JPG {
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.image = null;

    const types = {
      invoice: 'invoices',
      creditNote: 'invoices/credit-notes',
      dunning: 'dunnings',
      offer: 'offer',
      orderConfirmation: 'order-confirmation'
    };

    if (this.type && this.type in types) {
      this.load(types[this.type]);
    }
  }

  load(type) {
    if (this.number && type) {
      this.$http.get(`/${type}/${this.number}?format=base64`)
        .then((resp) => {
          if (resp && resp.data) {
            this.image = resp.data;
          }
        });
    }
  }
}

JPG.$inject = ['$http'];

const jpg = {
  bindings: {
    number: '<',
    type: '<'
  },
  controller: JPG,
  template: `
    <img ng-show="$ctrl.image" ng-src="data:image/jpg;base64,{{ $ctrl.image }}" alt="" class="document-preview" />
  `
};

angular
  .module('SendRegning')
  .component('jpg', jpg);
